import { create } from "zustand";

const initialTheme = {
  "primary-background": "rgb(0, 0, 0)",
  "primary-background-dark": "rgb(0, 0, 0)",
  "primary-text-color": "rgb(255, 255, 255)",
};

// Selector functions
export const selectTheme = (state) => state.theme;

const useThemeStore = create((set) => ({
  theme: { ...initialTheme },

  // Mirrors SET_THEME_COLORS
  setThemeColors: (colors) =>
    set((state) => ({ theme: { ...state.theme, ...colors } })),

  // Mirrors RESET_THEME_COLORS
  resetThemeColors: () => set({ theme: { ...initialTheme } }),
}));

export default useThemeStore;
